import React from 'react';
import Intl from '@fx-ui/intl';
import {
    compact,
    getOdmId,
    getQueryRouter,
    getUrlParameter,
    isEmpty,
    isMobileUA,
    isNumber,
    redirect
} from '~/utils';
import { SITE_ROUTER, URL_PARAMETER } from '~/constants';
import classNames from 'classnames';
import { RegisterSwitchProps } from '../../../../interfaces';

const RegisterSwitch: React.FC<RegisterSwitchProps> = ({ className }) => {
    const redirectToRegister = () => {
        const redirect_uri = getUrlParameter(URL_PARAMETER.REDIRECT_URI);
        const suite_id = window.platform_suite_id;
        const suite_metadata = window.platform_suite_metadata;
        const odmId = getOdmId();
        const url = getQueryRouter(
            compact([
                !isEmpty(redirect_uri) && {
                    key: URL_PARAMETER.REDIRECT_URI,
                    value: encodeURIComponent(redirect_uri)
                },
                isNumber(suite_id) && {
                    key: URL_PARAMETER.SUITE_ID,
                    value: suite_id
                },
                suite_metadata && {
                    key: URL_PARAMETER.SUITE_METADATA,
                    value: suite_metadata
                },
                odmId && {
                    key: URL_PARAMETER.ODM_ID,
                    value: odmId
                }
            ]),
            SITE_ROUTER.AUTHENTICATION.REGISTER
        );
        redirect(url);
    };

    return (
        <div
            className={classNames('fx-register-switch', className, {
                'is-mobile': isMobileUA()
            })}
        >
            <span>{Intl.get('account.signin.register.noAccount')}</span>
            <span className="register-btn" onClick={redirectToRegister}>
                {Intl.get('account.signin.register')}
            </span>
        </div>
    );
};

export default RegisterSwitch;
